import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';
import config from '../config/config';

// Контекст для налаштувань
const SettingsContext = createContext();

// Провайдер налаштувань
export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.apiUrl}/api/settings/public`);
      setSettings(response.data);
      setError(null);
    } catch (err) {
      console.error('Error loading settings:', err);
      setError(err);
      // Встановлюємо базові налаштування при помилці
      setSettings({
        site_name: 'Cookly',
        site_description: 'Найкращі рецепти від кулінарів з усього світу',
        default_language: 'uk',
        supported_languages: 'uk,en'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const getSetting = (key, defaultValue = null) => {
    return settings[key] !== undefined ? settings[key] : defaultValue;
  };

  const value = {
    settings,
    loading,
    error,
    getSetting,
    reload: loadSettings
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

// Хук для використання налаштувань
export const useSettings = () => {
  const context = useContext(SettingsContext);
  
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  
  return context;
};

// Хук для конкретного налаштування
export const useSetting = (key, defaultValue = null) => {
  const { getSetting } = useSettings();
  return getSetting(key, defaultValue);
};

export default useSettings;